import script from "./products.vue?vue&type=script&setup=true&lang=ts"
export * from "./products.vue?vue&type=script&setup=true&lang=ts"

import "./products.vue?vue&type=style&index=0&id=79010ab4&lang=scss"

const __exports__ = script;

export default __exports__